import {http} from '@/helpers/http-helper';

class BankReturn {
    constructor(
        uuid,
        documentHeaderId,
        documentHeaderDate,
        createdBy,
        createdAt,
        seatsDiary,
        receipts,
        amount,
        headquarters
    ) {
        this.uuid = uuid;
        this.documentHeaderId = documentHeaderId;
        this.documentHeaderDate = documentHeaderDate;
        this.createdBy = createdBy;
        this.createdAt = createdAt;
        this.seatsDiary = seatsDiary;
        this.receipts = receipts;
        this.amount = amount;
        this.headquarters = headquarters;
    }
}

export const getBankReturns = (searchData) => {
    return new Promise((resolve, reject) => {
        const url = 'bank-returns';
        http.get(url, searchData)
            .then((response) => {
                if (response.status === 200) {
                    let bankReturns = [];
                    response.data.bankReturns.forEach((bankReturn) => {
                        bankReturns.push(
                            new BankReturn(
                                bankReturn.uuid,
                                bankReturn.documentHeaderId,
                                new Date(bankReturn.documentHeaderDate),
                                bankReturn.createdBy,
                                new Date(bankReturn.createdAt),
                                bankReturn.seatsDiary,
                                bankReturn.receipts,
                                bankReturn.amount,
                                bankReturn.headquarters
                            ));
                    });

                    resolve({
                        bankReturns: bankReturns,
                        count: response.data.count
                    });
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getBankReturn = (bankReturnId) => {
    return new Promise((resolve, reject) => {
        const url = 'bank-returns/' + bankReturnId;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    const bankReturn = response.data;
                    resolve(new BankReturn(
                        bankReturn.uuid,
                        bankReturn.documentHeaderId,
                        new Date(bankReturn.documentHeaderDate),
                        bankReturn.createdBy,
                        new Date(bankReturn.createdAt),
                        bankReturn.seatsDiary,
                        bankReturn.receipts,
                        bankReturn.amount,
                        bankReturn.headquarters))
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteBankReturn = (bankReturnId) => {
    return new Promise( (resolve, reject) => {
        const url = 'bank-returns/' + bankReturnId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getBankReturnSeatsFiles = (bankReturnId) => {
    return new Promise((resolve, reject) => {
        const url = 'bank-returns/' + bankReturnId + '/seats/download';
        http.get(url, {}, 'arraybuffer')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};